export default "__VITE_ASSET__Dz_5NjCf__"